'use strict';

var _toConsumableArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _getPrototypeOf = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Hoek = require('@hapi/hoek');

var Any = require('../any');

var internals = {
  Set: require('../../set')
};

internals.Boolean = /*#__PURE__*/function (_Any) {
  _inherits(_class, _Any);

  var _super = _createSuper(_class);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this);
    _this._type = 'boolean';
    _this._flags.insensitive = true;
    _this._inner.truthySet = new internals.Set();
    _this._inner.falsySet = new internals.Set();
    return _this;
  }

  _createClass(_class, [{
    key: "_base",
    value: function _base(value, state, options) {
      var result = {
        value: value
      };

      if (typeof value === 'string' && options.convert) {
        var normalized = this._flags.insensitive ? value.toLowerCase() : value;
        result.value = normalized === 'true' ? true : normalized === 'false' ? false : value;
      }

      if (typeof result.value !== 'boolean') {
        result.value = this._inner.truthySet.has(value, null, null, this._flags.insensitive) ? true : this._inner.falsySet.has(value, null, null, this._flags.insensitive) ? false : value;
      }

      result.errors = typeof result.value === 'boolean' ? null : this.createError('boolean.base', {
        value: value
      }, state, options);
      return result;
    }
  }, {
    key: "truthy",
    value: function truthy() {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      var obj = this.clone();
      values = Hoek.flatten(values);

      for (var i = 0; i < values.length; ++i) {
        var value = values[i];
        Hoek.assert(value !== undefined, 'Cannot call truthy with undefined');

        obj._inner.truthySet.add(value);
      }

      return obj;
    }
  }, {
    key: "falsy",
    value: function falsy() {
      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        values[_key2] = arguments[_key2];
      }

      var obj = this.clone();
      values = Hoek.flatten(values);

      for (var i = 0; i < values.length; ++i) {
        var value = values[i];
        Hoek.assert(value !== undefined, 'Cannot call falsy with undefined');

        obj._inner.falsySet.add(value);
      }

      return obj;
    }
  }, {
    key: "insensitive",
    value: function insensitive(enabled) {
      var insensitive = enabled === undefined ? true : !!enabled;

      if (this._flags.insensitive === insensitive) {
        return this;
      }

      var obj = this.clone();
      obj._flags.insensitive = insensitive;
      return obj;
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = _get(_getPrototypeOf(_class.prototype), "describe", this).call(this);

      description.truthy = [true].concat(_toConsumableArray(this._inner.truthySet.values()));
      description.falsy = [false].concat(_toConsumableArray(this._inner.falsySet.values()));
      return description;
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Boolean();